import { BaseService } from './BaseService';
import { User, Recipe } from 'src/types';

export class ProfileService extends BaseService {
  async updateProfile(id: number | string, body: Partial<User>, params?: any): Promise<User> {
    return this.put(`/api/v1/users/${id}`, body, params);
  }
  async getProfile(id: number | string | null): Promise<User> {
    return this.get(`/api/v1/users/${id}`);
  }
  async getRecentlyViewedRecipes(): Promise<Recipe[]> {
    return this.get(`/api/v1/recipes/recent_views`);
  }
}

export default new ProfileService();
